import { RightChevron, LeftChevron } from "@components/atoms/Icons/index";
import { PropsWithChildren, MouseEventHandler } from "react";

interface BaseArrowProps extends PropsWithChildren {
  onClick: MouseEventHandler<HTMLButtonElement>;
  canContinue: boolean;
}

const BaseArrow = ({ onClick, canContinue, children }: BaseArrowProps) => (
  <button
    onClick={canContinue ? onClick : undefined}
    className={`p-2 rounded-full ${
      canContinue ? "" : "opacity-50 cursor-not-allowed"
    }`}
  >
    {children}
  </button>
);

type ArrowProps = Omit<BaseArrowProps, "direction" | "children">;

export const ArrowNext = (props: ArrowProps) => (
  <BaseArrow {...props}>
    <RightChevron width="12" height="18" />
  </BaseArrow>
);

export const ArrowPrev = (props: ArrowProps) => (
  <BaseArrow {...props}>
    <LeftChevron width="12" height="18" />
  </BaseArrow>
);
